import React from 'react';
import { View } from 'react-native';

export const Divider = () => {
  return <View className="h-1 w-full border-spacing-1 bg-background-gray" />;
};
